import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export const transformerSeparationAct = (values?: ModelEventoDTO): SectionVM | undefined => {
  if (!values) {
    return;
  }

  return {
    typeAct: CodeTypeAct.attoDigitale,
    actForm: {
      idAnsc: values.idAnsc,
      dateAct: values?.dataformazione ? DateTime.fromISO(values?.dataformazione) : null,
      italian: values?.idComuneRegistrazione
        ? {
            municipality: {
              id: values?.idComuneRegistrazione || '',
              code: values?.idComuneRegistrazione
                ? Number.parseInt(values?.idComuneRegistrazione, 10)
                : undefined,
              description: values.nomeComuneRegistrazione || '',
              province: values.siglaProvinciaRegistrazione || '',
              idProvince: values.idProvinciaRegistrazione
                ? Number.parseInt(values.idProvinciaRegistrazione, 10)
                : undefined,
            },
          }
        : undefined,
      typeEvent: values?.idtipocontenuto || '',
      register: values.idTipoEvento || '',
      year: values?.annoAtto || '',
      municipalNumber: values?.numeroatto || '',
    },
  };
};
